<template>
  <div class="home-page">
    <!-- 顶部导航栏 -->
    <header>
      <img src="assets/logo.png" id="logo" />
      <div id="guide">
        <a href="https://moseeker.com">公司首页</a>
        <router-link :to="'/'" class="active">势能大会</router-link>
        <router-link :to="'awards'">势能大奖</router-link>
      </div>
    </header>
    <!-- 首屏 大标题 -->
    <div id="first-screen">
      <img
        src="assets/main_title.png"
        alt="Momentum 中国人才势能大会 - 人工智能是人才招聘的新势能"
      />
    </div>
    <!-- 标语 时间 地点 -->
    <div id="slogan">
      <p>
        一场中国真正人力资源领域的高端对话<br />
        一场聚焦招聘技术与组织变革的盛会
      </p>
      <div class="iconfont time">2021.1.8</div>
      <div class="iconfont location">上海</div>
    </div>
    <!-- 大会介绍 -->
    <div id="brief">
      <div class="title gradient-bg">大会介绍<span>Introduction</span></div>
      <div class="content">
        <p>
          此次盛会邀请了<b>150家</b>世界500强公司和各行业领军企业的人力资源领导人，仅限受邀者参加。现场汇集了全行业<b>具有影响力的大咖</b>，直接推动当今人才和组织<b>创新变革的势能</b>。
        </p>
        <p>
          大会聚焦探讨了<b>人工智能招聘、雇主品牌管理、员工信息安全</b>等前沿热点话题，同时开启火热线上直播，实时同步大会精彩动态，传播新的资讯，激发人力资源行业内互动与交流。
        </p>
      </div>
    </div>
    <!-- 活动亮点 -->
    <div id="highlight">
      <div class="title gradient-bg">活动亮点<span>Highlights</span></div>
      <div class="content">
        <div class="highlight-frame" v-for="(v, i) in d.Highlight" :key="i">
          <div class="major">{{ v.title }}</div>
          <div class="desc">{{ v.desc }}</div>
        </div>
      </div>
    </div>
    <!-- 日程 -->
    <div id="agenda">
      <div class="title gradient-bg">1月8日 ｜ 日程<span>Agenda</span></div>
      <div class="content">
        <div
          :class="['agenda-frame', { minor: v.minor }]"
          v-for="(v, i) in d.Agenda"
          :key="i"
        >
          <div class="time">{{ v.time }}</div>
          <div class="info">
            <div class="topic">{{ v.topic }}</div>
            <div class="name" v-if="v.name">{{ v.name }}</div>
            <div class="desc" v-if="v.co">{{ v.co }} {{ v.title }}</div>
          </div>
        </div>
      </div>
    </div>
    <!-- 重磅嘉宾 -->
    <div id="speaker">
      <div class="title double-text">
        <div class="major">重磅嘉宾<span>Speaker</span></div>
        <div class="shadow">重磅嘉宾<span>Speaker</span></div>
      </div>
      <div class="content">
        <div class="speaker-frame" v-for="(v, i) in d.Speaker" :key="i">
          <img
            :src="'assets/speaker/' + v.img + '.jpg'"
            class="avatar"
            :alt="v.name"
          />
          <div class="info">
            <div class="name">{{ v.name }}</div>
            <div class="company">{{ v.co }}</div>
            <div class="job_title">{{ v.title }}</div>
          </div>
        </div>
      </div>
    </div>
    <!-- 主旨演讲 -->
    <div id="report" class="style1">
      <div class="title gradient-bg">主旨演讲<span>Keynote Speech</span></div>
      <div class="content">
        <a
          class="report-frame"
          v-for="(v, i) in d.Report"
          :key="i"
          :href="v.link"
        >
          <div
            class="cover"
            :style="{ backgroundImage: 'url(assets/report/' + v.img + '.jpg)' }"
          >
            <h1>{{ v.topic }}</h1>
          </div>
          <div class="info">
            <span class="desc">{{ v.desc }}</span>
            <span class="get_report">观看完整视频</span>
          </div>
        </a>
      </div>
    </div>
    <!-- 圆桌论坛 -->
    <div id="roundtable" class="style1">
      <div class="title gradient-bg">圆桌论坛<span>Roundtable</span></div>
      <div class="content">
        <a
          class="report-frame"
          v-for="(v, i) in d.Roundtable"
          :key="i"
          :href="v.link"
        >
          <div
            class="cover"
            :style="{
              backgroundImage: 'url(assets/roundtable/' + v.img + '.jpg)',
            }"
          >
            <h1>{{ v.topic }}</h1>
          </div>
          <div class="info">
            <span class="desc">{{ v.desc }}</span>
            <span class="get_report">观看完整视频</span>
          </div>
        </a>
      </div>
    </div>
    <!-- 合作伙伴 -->
    <div id="partner">
      <div class="title gradient-bg">合作伙伴</div>
      <div class="content">
        <div><img src="assets/partner1.png" alt="美国高校驻华联盟" /></div>
        <div><img src="assets/partner2.png" alt="亿欧 EqualOcean" /></div>
      </div>
    </div>
    <!-- 页脚 -->
    <footer>
      <span>© 2021 MoSeeker</span>
      <span id="icp">沪ICP证B2-20170397号</span>
    </footer>
  </div>
</template>
<script>
import momentum2020 from "@/data/Momentum2020.json";
export default {
  wx() {
    return [
      {
        name: "share",
        option: {
          link: window.location.href,
          title: document.title,
          imgUrl:
            "https://www.moseeker.com/theme/static/img/moats_logo_share.png",
          desc: "人工智能是人才招聘的新势能",
        },
      },
    ];
  },

  data: function() {
    return {
      d: momentum2020,
      platform: this.$parent.platform,
    };
  },
  // beforeCreate() {
  //     document.title = 'MCN MIKADUKI'
  // },
  mounted() {
    // document.querySelector("#speaker").scrollIntoView()
    // start wx share.
    console.log('0')
    this.$emit("vuewx:show");
  },
};
</script>
<style lang="less">
@import "@/css/global.less";
.home-page {
  #slogan {
    p {
      font-size: calc(1em + 0.5vw);
      color: white;
      font-weight: bold;
      font-style: italic;
    }

    div {
      font: bolder calc(1em + 0.5vw) / 1.5 @font-family;
    }
  }

  // ==================== 活动亮点 start
  #highlight {
    .content {
      display: grid;
      .column_2_3;
      gap: 2em 1em;
      padding: 1em 2px;
    }

    // ==================== 活动亮点 start
    .highlight-frame {
      // margin: 1em;
      .frame;

      // 绘制引号
      &:before {
        content: "\e82c";
        color: @blue;
        position: absolute;
        top: -0.65em;
        left: 0.1em;
        font: 2em/1 "iconfont" !important;
      }

      .major {
        font: bolder 1.5em/1.25 @font-family;
      }

      // .desc {
      //     font-size: .8em;
      // }
    }
  }

  // ==================== 活动亮点 end

  // ==================== 日程 start
  #agenda {
    display: none; // Daisy 要求去掉

    .content {
      @bd: 6px; // 时间左侧的点的宽度

      .agenda-frame {
        display: flex;
        flex-flow: row nowrap;
        align-items: flex-start;
        width: 100%;
        padding: 1em 0;
        line-height: 1.2em;
        position: relative;

        .time {
          font-weight: bold;
          flex: none;
          width: 8.5em;
          line-height: 2rem;
          display: flex;
          align-items: center;
        }

        // 时间左侧的点
        .time:before {
          content: "";
          display: inline-block;
          width: @bd;
          height: @bd;
          background: white;
          border-radius: 50%;
          margin: 0 calc(@bd + 0.5em) 0 @bd;
          box-shadow: 0 0 0 calc(@bd / 2) lighten(@blue, 25%), 0 0 0 @bd @blue;
        }

        // 连着点的线(每个块都画一条线并向下位移一些，最后一个块不画。)
        &:after {
          content: "";
          height: 100%;
          width: 10px;
          border-left: 2px dotted @blue;
          position: absolute;
          top: 1.6em;
          left: calc(@bd + 2px);
          z-index: -9;
        }

        // &:first-child:after{
        //     top:1.6em;
        //     height:calc(100% - 1.6em);
        // };
        &:last-child:after {
          display: none;
        }

        .info {
          // 让内容识别\n换行符
          * {
            white-space: pre-wrap;
          }

          .topic {
            font: bolder 1.2em/2rem @font-family;
          }
        }
      }

      .minor {
        padding-top: 0;

        * {
          font-weight: 400 !important;
        }

        .time:before {
          box-shadow: 0 0 0 calc(@bd / 2) @blue;
        }
      }
    }
  }

  // ==================== 日程 end

  // ==================== 嘉宾 start
  #speaker {
    .content {
      display: grid;
      .column_2_3;
      gap: 2em 0em;
    }

    .speaker-frame {
      position: relative;

      .avatar {
        width: 120px;
        width: ~"min(calc(80px + 4vw), 160px)";
        border-radius: 50%;
        object-fit: cover;
        position: absolute;
        z-index: -1;

        &:before {
          content: "";
          padding-top: 100%;
        }
      }

      .info {
        background: linear-gradient(
          100deg,
          rgba(0, 60, 180, 0.8) 30%,
          rgba(0, 60, 180, 0) 90%
        );
        margin-left: 60px;
        margin-left: ~"min(calc(20px + 2vw), 80px)";
        margin-top: 90px;
        margin-top: ~"min(calc(60px + 3vw), 120px)";
        padding: 0.5em 1em;
        font-size: 0.8em;
        line-height: 1.25em;

        .name {
          font: bold 1.25em/1.5 @font-family;
          color: white;
        }
      }
    }
  }

  // ==================== 嘉宾 end

  // ==================== 报告 start
  #report,
  #roundtable {
    .content {
      display: grid;
      .column_1_2;
      gap: 1em;
    }

    .report-frame {
      transition: 1s;
      display: flex;
      flex-flow: column nowrap;
      font-size: 0.8em;
      font-size: ~"min(calc(.6rem + 1vw), 1rem)";

      .cover {
        width: 100%;
        position: relative;
        transition: 1s;
        background-size: 101%;
        background-position: 50% -1px;
        background-repeat: no-repeat;
        border-radius: 0.5em;
        overflow: hidden;

        &:before {
          content: "";
          padding-top: 42%; //750:320;
          display: block;
        }
      }

      &:hover .cover {
        background-size: 120%;
      }

      h1 {
        position: absolute;
        bottom: 0;
        width: 100%;
        background: linear-gradient(0, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0));
        color: white;
        font-size: 1.25em;
        margin: 0;
        padding: 0.25em 0.5em;
        text-shadow: 0 0px 10px #000, 0 0 2px #000;
      }

      .info {
        padding: 1em 0.5em;
        line-height: 1.25em;

        .desc {
          transition: all 0.3s ease;
          color: rgba(255, 255, 255, 0.75);
          white-space: pre-wrap; // 让内容识别\n换行符

          &:after {
            content: " ";
          }
        }

        .get_report {
          // transition: all 0.3s ease;
          display: inline-block;
          border: none;
          padding: 0;
          margin: 0;
          align-self: flex-end;
          color: @blue;
        }
      }

      &:hover {
        .cover {
          box-shadow: 0 0 1em @blue, 0 0 0 1px white;
        }

        .desc {
          color: white;
        }

        .get_report {
          color: #2789eb;
          display: inline-block;
          .animateBG();
          background-color: #2987e6;
          -webkit-background-clip: text;
          -moz-background-clip: text;
          -webkit-text-fill-color: transparent;
          -moz-text-fill-color: transparent;
          color: white;
        }
      }
    }
  }

  // ==================== 报告 end

  // ==================== 合作伙伴 start
  #partner {
    display: none; // Dow 要求去掉

    .content {
      display: flex;

      & > div {
        width: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        flex: none;
        margin: 1em 0;

        img {
          max-width: 80%;
          max-height: 4em;
        }
      }
    }
  }

  // ==================== 合作伙伴 end
}
</style>
